import { AdobeMethods } from '../../../../services/adobe-launch/adobe-launch.methods';
import { AdobePageName } from '../../../../services/adobe-launch/adobe-launch.pages';
import { AdobeAnalyticsProcessStep } from '../../../../services/adobe-launch/adobe-launch.process';
import { AnalyticsCtaType } from '../../../../services/adobe-launch/adobe-launch.cta';
import { AdobeGranteeFlowType, AdobeGranteeLimitedFlow } from '../grantee-flows.interface';

export function getAdobeConfigData(granteeFlow: AdobeGranteeLimitedFlow) {
    const flowMappings: Record<
        AdobeGranteeLimitedFlow,
        { pageName: AdobePageName; ctaLocation: AdobeAnalyticsProcessStep }
    > = {
        [AdobeGranteeFlowType.NEW_LIMITED]: {
            pageName: AdobePageName.GRANTEE_AUTH_AGREEMENT_GRANTEE_NEW,
            ctaLocation: AdobeAnalyticsProcessStep.GRANTEE_AUTH_AGREEMENT_NEW,
        },
        [AdobeGranteeFlowType.NON_VG_CLIENT_LIMITED]: {
            pageName: AdobePageName.GRANTEE_NVG_AGREEMENT_LIMITED,
            ctaLocation: AdobeAnalyticsProcessStep.NON_VG_CLIENT_AGREEMENT_LIMITED,
        },
        [AdobeGranteeFlowType.EXISTING_LIMITED]: {
            pageName: AdobePageName.GRANTEE_AUTH_AGREEMENT_GRANTEE_ON_LIST,
            ctaLocation: AdobeAnalyticsProcessStep.GRANTEE_AUTH_AGREEMENT_ON_LIST,
        },
    };

    const { pageName, ctaLocation } = flowMappings[granteeFlow];

    return {
        ngOnInit: [
            {
                method: AdobeMethods.PAGE_LOAD,
                data: [pageName],
            },
        ],
        onNextStepLoad: [
            {
                method: AdobeMethods.TRACK_ACTION,
                data: [
                    {
                        location: [ctaLocation],
                        ctaName: AdobeAnalyticsProcessStep.GRANTEE_STEP_AGREE_AND_SUBMIT,
                        ctaType: AnalyticsCtaType.BUTTON,
                        fireTrackLink: true,
                    },
                ],
            },
        ],
    };
}
